import { ShippingDocumentKind } from "generated-graphql/graphql";

import { formatContainerDate, NO_VALUE_PLACEHOLDER } from "../Containers/containerDisplay";

export { NO_VALUE_PLACEHOLDER };
export const formatShippingDocumentDate = formatContainerDate;

/** What the list's Ship Date cell reads when the document carries no ship date. */
export const MISSING_SHIP_DATE_LABEL = "No ship date";

/**
 * Shown on the review form and the edit form. A ship date is not required to
 * save, deliberately, so this names the consequence instead of blocking: the
 * document is listed under the year it was saved.
 */
export const MISSING_SHIP_DATE_WARNING =
  "No ship date. This document saves, and Shipment Documents lists it under the year it was saved rather than the year it shipped.";

export const SHIPPING_DOCUMENT_KIND_LABELS: Record<ShippingDocumentKind, string> = {
  [ShippingDocumentKind.BillOfLading]: "Bill of Lading",
  [ShippingDocumentKind.Manifest]: "Manifest",
  [ShippingDocumentKind.Other]: "Other",
};

export const SHIPPING_DOCUMENT_KIND_OPTIONS = Object.values(ShippingDocumentKind).map((value) => ({
  value,
  label: SHIPPING_DOCUMENT_KIND_LABELS[value],
}));
